import React, { useEffect, useRef, useState } from "react";
import { MainWrapper } from "../../component/MainWrapper";
import { DateFormat } from "sr/helpers/functions/DateFormat";
import getTimeFromDate from "sr/helpers/functions/getTimeFromDate";
import { ChatBottom } from "../../component/Messages/ChatBottom";
import { getUserDetails } from "sr/helpers/functions/getUserDetails";
import { Input, toAbsoluteUrl } from "sr/helpers";
import { ModelWrapperWithButton } from "../../component/ModelWrapperWithButton";
import { ReactDatePicker } from "sr/helpers/ui-components/ReactDatePicker";
import { FormattedMessage } from "react-intl";
import { formatISO } from "date-fns";
import { useNavigate, useParams } from "react-router-dom";
import { HandleApiError } from "sr/helpers/functions/HandleApiError";
import { getJob } from "sr/utils/api/individual/job/getJob";
import { useGet } from "app/pages/company/Hooks/Api/useGet";
import { getIndividual } from "sr/utils/api/individual/getIndividual";
import { getMessage } from "sr/utils/api/cleaner/getMessage";
import { updateJob } from "sr/utils/api/individual/job/updateJob";
import { uploadFile } from "sr/utils/api/uploadFile";
import { ChatImg } from "../component/ChatImg";
import { scrollToBottom } from "sr/helpers/functions/scrollToBottom";
import { LoaderFullScreen } from "sr/layout/common/LoaderFullScreen";
import ContentWithSpinner from "sr/layout/common/ContentWithSpiner";
import { Rating } from "./component/Rating";
import { createfeedBack } from "sr/utils/api/company/workorder/createfeedBack";
import { CHAT_TYPE } from "sr/i18n/messages/setting";
import { useSocket } from "app/pages/component/SocketContext";
import { createIndFeedback } from "sr/utils/api/individual/feedback/createIndFeedback";
import { getIndFeedback } from "sr/utils/api/individual/feedback/getIndFeedback";
import { ViewRating } from "./component/ViewRating";
import { getFiles } from "sr/utils/api/getFiles";
import { getFile } from "sr/utils/api/getFile";
import { ModelWrapper } from "../../component/ModelWrapper";
import { DeleteConfirmation } from "app/pages/component/DeleteConfirmation";
import { ReactTimePicker } from "sr/helpers/ui-components/ReactTimePicker";
import { getFeeTransparency } from "sr/utils/api/fee/getFeeTransparency";
import { FeeBreakdownBox } from "app/pages/component/FeeBreakdownBox";
import {
  BACKGROUND_CHECK_STATUSES,
  STRIPE_ONBOARDING_STATUSES,
} from "sr/constants/common";

export const ConfirmAndChat = () => {
  const [message, setMessage] = useState("");
  const [allmessage, setAllMessage] = useState([]);
  const messagesEndRef = useRef();
  const [data, setData] = useState<any>();
  const [userId, setUserid] = useState();
  const [model, setModel] = useState("");
  const [startDate, setStartDate] = useState(new Date());
  const [rate, setRate] = useState(null);
  const [jobId, setJobId] = useState<string>("");
  const [loader, setLoader] = useState("fetch");
  const [imageId, setImageId] = useState("");
  const [imageUrl, setImageUrl] = useState("");
  const [allonlineUser, setAllOnlineUser] = useState(null);
  const [showRating, setShowRating] = useState("");
  const [allReview, setAllReview] = useState([]);
  const [profileImg, setProfileImg] = useState<any>();
  const [showDelete, setShowDelete] = useState(false);

  const [from, setFrom] = useState("00:00");
  const [to, setTo] = useState("23:59");
  const [feeTransparency, setFeeTransparency] = useState<any>(null);
  const [feeTransparencyLoading, setFeeTransparencyLoading] = useState(false);
  const feeTransparencyReqIdRef = useRef(0);

  const socket = useSocket();
  const { loader: userloader, getData: fetchData, data: userData } = useGet();

  useEffect(() => {
    const { user_id } = getUserDetails();
    setUserid(user_id);
  }, []);
  useEffect(() => {
    const fetchDetails = async (userId) => {
      const queryParams = new URLSearchParams();
      if (userId) queryParams.append("id", userId);
      await fetchData(() => getIndividual(queryParams));
    };
    if (userId) {
      fetchDetails(userId);
    }
  }, [userId]);
  const param = useParams();
  useEffect(() => {
    const { id } = param;
    setJobId(id);
  }, [param]);
  const onCheckModel = () => {
    setModel("");
  };

  useEffect(() => {
    if (data) {
      setStartDate(data?.schedule_date);
      setFrom(data?.start_time || data?.from || "00:00");
      setTo(data?.end_time || data?.to || "23:59");
    }
  }, [data]);

  useEffect(() => {
    const tx = data?.payment_transaction_detail;
    const hasTxAmounts =
      tx &&
      (tx?.job_provider_paid_amount !== undefined ||
        tx?.job_provider_fee_amount !== undefined ||
        tx?.amount !== undefined);

    if (hasTxAmounts) {
      setFeeTransparency(tx);
      setFeeTransparencyLoading(false);
      return;
    }

    const amount = Number(data?.rate);
    const start_time = from;
    const end_time = to;
    if (
      !amount ||
      Number.isNaN(amount) ||
      amount <= 0 ||
      !start_time ||
      !end_time
    ) {
      setFeeTransparency(null);
      setFeeTransparencyLoading(false);
      return;
    }

    const reqId = feeTransparencyReqIdRef.current + 1;
    feeTransparencyReqIdRef.current = reqId;
    setFeeTransparencyLoading(true);
    (async () => {
      try {
        const res = await getFeeTransparency({
          jobType: "individual",
          amount,
          start_time,
          end_time,
        });
        if (reqId !== feeTransparencyReqIdRef.current) return;
        if (res?.success === true) {
          setFeeTransparency(res?.data || null);
        } else {
          setFeeTransparency(null);
        }
      } catch (e) {
        if (reqId !== feeTransparencyReqIdRef.current) return;
        setFeeTransparency(null);
      } finally {
        if (reqId !== feeTransparencyReqIdRef.current) return;
        setFeeTransparencyLoading(false);
      }
    })();
  }, [data?.payment_transaction_detail, data?.rate, from, to]);

  const fetchJob = async () => {
    const queryParams = new URLSearchParams();
    queryParams.append("id", jobId);

    try {
      const res = await getJob(queryParams);

      if (res?.success === true) {
        const jobData = res?.data;

        setData(jobData);

        // ✅ set values directly here
        setStartDate(jobData?.schedule_date);
        setFrom(jobData?.start_time || jobData?.from || "00:00");
        setTo(jobData?.end_time || jobData?.to || "23:59");
      }
    } catch (e: any) {
      HandleApiError(e);
    }
  };
  useEffect(() => {
    if (jobId) {
      fetchJob();
      fetchChat(jobId);
    }
  }, [jobId]);
  useEffect(() => {
    setStartDate(data?.schedule_date);
  }, [data?.schedule_date]);

  useEffect(() => {
    if (!userId || !socket) return;
    if (socket) {
      socket.emit("register", userId);
      socket.emit("getonlineusers", userId);
      socket.off("sendmessage");
    }
    socket.on("sendmessage", ({ from, messagewithFullData: message }) => {
      if (message?.recipient_id?.id === userId) {
        const currentDateTime = formatISO(new Date());
        const newmessage = {
          createdAt: currentDateTime,
          ...message,
          type: message?.type === "message" ? "chat" : message?.type,
        };
        setAllMessage((preview) => [...preview, newmessage]);
        if (
          ["job_accepted", "job_rejected", "start_job", "end_job"].includes(
            message?.type,
          )
        ) {
          fetchJob();
        }
      }
    });
    socket.on("getonlineusers", ({ users }) => {
      setAllOnlineUser(users);
    });
    return () => {
      socket.off("sendmessage");
      socket.off("getonlineusers");
    };
  }, [userId, socket, jobId]);
  const sendMessage = () => {
    if (!message?.trim()?.length && !imageId) {
      return;
    }
    const payload = {
      message: message,
      recipient_id: data?.cleaner_id?._id,
      sender_id: userId,
      individual_job_id: data?.id,
      file_id: imageId,
      sender_id_type: "individual",
      recipient_id_type: "cleaner",
      type: "chat",
      // Ensure this resolves to the correct recipient user ID
    };

    socket.emit("sendmessage", payload); // Match the event name in the backend
    setMessage(""); // Clear the input
    const currentDateTime = formatISO(new Date());
    const newmessage = { createdAt: currentDateTime, ...payload };
    setAllMessage((preview) => [...preview, newmessage]);
    setImageId("");
    setImageUrl("");
  };
  const checkMessage = (item) => {
    if (item?.type === "date_change") {
      return item?.message?.replace(
        `${item?.sender_id?.first_name} ${item?.sender_id?.last_name}`,
        "You",
      );
    }

    if (item?.type === "rating") {
      return "You give rating";
    }

    if (item?.type === "request") {
      return `You have requested ${data?.cleaner_id?.first_name} ${data?.cleaner_id?.last_name}`;
    }
  };
  const fetchChat = async (individual_job_id) => {
    const queryParams = new URLSearchParams();
    queryParams?.append("individual_job_id", individual_job_id);
    try {
      const res = await getMessage(queryParams);
      if (res?.success === true) {
        const normalized = (res?.data || []).map((item) => ({
          ...item,
          type: item?.type === "message" ? "chat" : item?.type,
        }));
        setAllMessage(normalized);
        setLoader("");
      } else {
        setLoader("");
      }
    } catch (e) {
      setLoader("");
    }
  };
  const handleChange = async () => {
    try {
      setLoader("submit");

      const payload = {
        id: jobId,
        start_time: from,
        end_time: to,
      };

      const res = await updateJob(
        model === "changeDate" && {
          schedule_date: startDate,
          ...(data?.work_status === "rejected" && {
            work_status: "scheduled",
          }),
          ...payload,
        },
      );

      if (res?.success === true) {
        if (model === "changeDate") {
          const payload = {
            message: `${userData?.first_name} ${
              userData?.last_name
            } changed schedule to ${DateFormat(startDate)} (${from} - ${to})`,
            recipient_id: data?.cleaner_id?._id,
            sender_id: userId,
            individual_job_id: data?.id,
            type: "date_change",
            sender_id_type: "individual",
            recipient_id_type: "cleaner",
          };

          socket.emit("sendmessage", payload);

          const currentDateTime = formatISO(new Date());
          const newmessage = { createdAt: currentDateTime, ...payload };

          setAllMessage((preview) => [...preview, newmessage]);
          setModel("");
        }
      }
    } catch (e) {
      HandleApiError(e);
    } finally {
      setLoader("");
    }
  };
  const handleImage = async (e) => {
    setLoader("imageupload");
    const formData = new FormData();
    formData.append("individual_id", userId);
    formData.append("chat_img", e.target.files[0]);
    const result = await uploadFile(formData);
    if (result?.success === true) {
      setImageId(result?.data?.files[0].key);
      setImageUrl(URL.createObjectURL(e.target.files[0]));
      setLoader("");
    } else {
      setLoader("");
    }
  };
  const handleImageClick = () => {
    setImageId("");
    setImageUrl("");
  };
  useEffect(() => {
    scrollToBottom(messagesEndRef);
  }, [allmessage, showRating]);

  const handleData = async (ratingdetails) => {
    try {
      setLoader("submit");
      const feedbackpayload = {
        individual_job_id: data?.id,
        rating: ratingdetails?.rating,
        cleaner_id: data?.cleaner_id?._id,
        comment: ratingdetails?.feedback,
        channel: "itc",
      };
      const feedbackres = await createIndFeedback(feedbackpayload);
      if (feedbackres?.success === true) {
        setAllReview([feedbackres?.data]);
      }
      if (feedbackres?.success === true) {
        const payload = {
          message: `${userData?.first_name} ${userData?.last_name} gives rating`,
          recipient_id: data?.cleaner_id?._id,
          sender_id: userId,
          individual_job_id: data?.id,
          type: "rating",
          sender_id_type: "individual",
          recipient_id_type: "cleaner",
        };
        socket.emit("sendmessage", payload);
        setMessage(""); // Clear the input
        const currentDateTime = formatISO(new Date());
        const newmessage = { createdAt: currentDateTime, ...payload };
        setAllMessage((preview) => [...preview, newmessage]);
        setModel("");
        setShowRating("");
        setLoader("");
      } else {
        setLoader("");
      }
    } catch (e: any) {
      setLoader("");
    }
  };

  useEffect(() => {
    const fetchRating = async (individual_job_id) => {
      try {
        const queryParams = new URLSearchParams();
        queryParams.append("individual_job_id", individual_job_id);
        const res = await getIndFeedback(queryParams);
        if (res?.success === true) {
          setAllReview(res?.data.allReviews);
        }
      } catch (e) {}
    };
    if (jobId) {
      fetchRating(jobId);
    }
  }, [jobId]);
  const navigate = useNavigate();
  const handleCancel = async () => {
    setLoader("cancel");
    const payload = {
      id: jobId,
      work_status: "cancelled",
    };
    const res = await updateJob(payload);
    if (res?.success === true) {
      const payload = {
        message: `${userData?.first_name} ${userData?.last_name} cancel the job`,
        recipient_id: data?.cleaner_id?._id,
        sender_id: userId,
        individual_job_id: data?.id,
        type: "cancelled",
        sender_id_type: "individual",
        recipient_id_type: "cleaner",
      };
      socket.emit("sendmessage", payload);
      setShowDelete(false);
      navigate("/individual/jobs");
      setLoader("cancel");
    }
  };

  const fetchProfileImg = async (cleanerId) => {
    const params = {
      cleaner_id: cleanerId,
    };
    const profileImg = await getFiles(params);
    if (profileImg?.success === true) {
      const filterfile = profileImg?.data?.filter(
        (item) => item?.file?.fieldname === "profile_img",
      );
      if (filterfile && filterfile[0]?.file?.key) {
        const fileimg = await getFile(filterfile[0]?.file?.key);
        if (fileimg) {
          // const rawImageData = new Uint8Array(fileimg as ArrayBuffer);
          // const blob = new Blob([rawImageData], { type: 'image/png' });
          const newImageUrl = URL.createObjectURL(fileimg);
          setProfileImg(newImageUrl);
          return true;
        }
      }
    }
  };
  useEffect(() => {
    if (data?.cleaner_id?._id) {
      fetchProfileImg(data?.cleaner_id?._id);
    }
  }, [data?.cleaner_id?._id]);

  return (
    <MainWrapper>
      <ContentWithSpinner loader={loader === "fetch"} height="h-screen">
        <main className="pt-3">
          {(loader === "imageupload" ||
            loader === "submit" ||
            loader === "cancel") && <LoaderFullScreen />}
          <div className="bg-white max-w-[80%] mx-auto">
            <div className="flex justify-start items-center py-3 px-3 space-x-3">
              <div className="text-white h-16  w-16 flex items-center justify-center relative">
                <img
                  className="rounded-full"
                  src={` ${
                    profileImg
                      ? profileImg
                      : "/media/icons/displayProfilePlaceholder.png"
                  }`}
                  alt="user_img"
                ></img>
                <span className="bg-[#3fbb46] absolute bottom-1 w-4 h-4 rounded-lg right-2 "></span>
              </div>
              <div>
                <h1 className="text-2xl  text-[#595959] flex gap-2 items-center">
                  {data?.cleaner_id?.first_name} {data?.cleaner_id?.last_name}
                  {((data?.cleaner_id?.backgroundCheckStatus != undefined &&
                    [
                      BACKGROUND_CHECK_STATUSES.CLEAR,
                      BACKGROUND_CHECK_STATUSES.CONSIDER,
                    ].indexOf(data?.cleaner_id?.backgroundCheckStatus) !==
                      -1) ||
                    data?.cleaner_id?.stripe_customer_model
                      ?.stripe_onboarding_status ===
                      STRIPE_ONBOARDING_STATUSES.SUCCESS) && (
                      <span className="relative group w-6 h-6 inline">
                        <img
                          src="/media/icons/checkr-badge-pink-NB.png"
                          alt="Background check verified"
                          className="w-6 h-6"
                        />

                        {/* Tooltip */}
                        <div className="absolute left-0 top-full pt-2 w-52 hidden group-hover:block z-50">
                          <div className="bg-gray-900 text-white text-xs rounded-lg p-3 shadow-lg leading-relaxed">
                            Background Check Verified User
                          </div>
                        </div>
                      </span>
                    )}
                </h1>
                <p className="">
                  {allonlineUser && allonlineUser[data && data?.cleaner_id?._id]
                    ? "Online"
                    : "Recently seen"}
                </p>
              </div>
            </div>
            <hr className="border-2 border-neutral-200" />
            <div className="flex flex-col h-[75vh] justify-between">
              <div className="px-3 py-3">
                <div className="flex justify-between items-center">
                  <div>
                    <h1 className="text-2xl  text-[#595959]">{data?.title}</h1>
                    <p className="">
                      {data?.streetAddress} {data?.unitorapt}
                    </p>
                    {feeTransparencyLoading || feeTransparency ? (
                      <FeeBreakdownBox
                        className="mt-2 max-w-[320px]"
                        loading={feeTransparencyLoading}
                        rows={[
                          {
                            label: "Service amount",
                            value: Number(feeTransparency?.amount || 0),
                          },
                          {
                            label: "Service fee",
                            value: Number(
                              feeTransparency?.job_provider_fee_amount || 0,
                            ),
                          },
                        ]}
                        totalLabel="Total payable"
                        totalValue={Number(
                          feeTransparency?.job_provider_paid_amount || 0,
                        )}
                        status={
                          data?.payment_transaction_detail?.status || undefined
                        }
                      />
                    ) : null}
                  </div>
                  <div>
                    <div className="flex space-x-3">
                      {/* <button onClick={()=> setModel('changeRate')} className="rounded-lg font-bold bg-[#ff39b3] font-bold px-5 py-2  text-white cursor-pointer hover:bg-navy">Change Rate</button> */}
                      {data?.work_status === "completed" ? (
                        <>
                          {Array.isArray(allReview) &&
                            !allReview?.some(
                              (item) => item?.channel === "itc",
                            ) && (
                              <button
                                onClick={() =>
                                  setShowRating((data) =>
                                    data === "add" ? "" : "add",
                                  )
                                }
                                className="rounded-lg  bg-[#ff39b3] font-bold px-5 py-2  text-white cursor-pointer hover:bg-navy"
                              >
                                Give Rating
                              </button>
                            )}
                          {allReview?.length > 0 && (
                            <button
                              onClick={() =>
                                setShowRating((data) =>
                                  data === "view" ? "" : "view",
                                )
                              }
                              className="rounded-lg  bg-[#ff39b3] font-bold px-5 py-2  text-white cursor-pointer hover:bg-navy"
                            >
                              View Rating
                            </button>
                          )}
                        </>
                      ) : (
                        <button
                          onClick={() => setModel("changeDate")}
                          className="rounded-lg  bg-[#ff39b3] font-bold px-5 py-2  text-white cursor-pointer hover:bg-navy"
                        >
                          Change Date & Time
                        </button>
                      )}
                      {/* <button  className="rounded-lg font-bold bg-[#ff39b3] font-bold px-5 py-2  text-white cursor-pointer hover:bg-navy">Accept</button> */}
                      {data?.work_status !== "completed" &&
                        data?.work_status !== "cancelled" &&
                        data?.work_status !== "rejected" && (
                          <button
                            onClick={() => setShowDelete(true)}
                            className="rounded-lg font-bold text-white px-5 py-2  bg-red-500  border-2 cursor-pointer hover:text-white hover:border-white "
                          >
                            Cancel
                          </button>
                        )}
                    </div>
                  </div>
                </div>
              </div>
              <hr className="border-2 border-neutral-200" />
              <div
                ref={messagesEndRef}
                className="flex-1 h-[60vh] overflow-auto mb-3"
              >
                <div className="text-center mb-10 mt-3">
                  {DateFormat(data?.createdAt)}
                </div>
                <div className="flex items-center justify-center mb-4">
                  <div className="border-t flex-1 mr-4"></div>
                  <span className="text-black ">Today</span>
                  <div className="border-t flex-1 ml-4"></div>
                </div>
                <div className="text-center">
                  <div></div>
                  {allmessage
                    ?.sort((a, b) => {
                      const adate = new Date(a?.createdAt);
                      const bdate = new Date(b?.createdAt);

                      const differenceInMilliseconds =
                        adate.getTime() - bdate.getTime();
                      return differenceInMilliseconds;
                    })
                    .map((item) => (
                      <div>
                        {(item?.sender_id?.id || item?.sender_id) === userId ? (
                          item?.type === "chat" ? (
                            <div className="flex justify-end items-center space-x-2 px-2">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                focusable="false"
                                role="img"
                                fill="currentColor"
                                viewBox="0 0 24 24"
                                aria-hidden="true"
                                className="w-6 h-6 text-[#0d2d5e]"
                              >
                                <path d="M12 12c2.486 0 4.5-2.014 4.5-4.5S14.486 3 12 3a4.499 4.499 0 00-4.5 4.5C7.5 9.986 9.514 12 12 12zm0 2.25c-3.004 0-9 1.508-9 4.5v1.75a.5.5 0 00.5.5h17a.5.5 0 00.5-.5v-1.75c0-2.992-5.996-4.5-9-4.5z"></path>
                              </svg>
                              <div>
                                <div className="flex-1 flex justify-start items-center space-x-2">
                                  <div className=" text-base"> You </div>
                                  <div className="text-sm">
                                    {getTimeFromDate(item?.createdAt)}
                                  </div>
                                </div>
                                <div className="text-[#595959]">
                                  {item?.message}
                                </div>
                                {item?.file_id && (
                                  <ChatImg item={item}></ChatImg>
                                )}
                              </div>
                            </div>
                          ) : (
                            Object.values(CHAT_TYPE)?.includes(item?.type) && (
                              <div className="text-center">
                                <div className="rounded-lg inline-block bg-[#ff39b3] font-bold px-5 py-0.5  text-white mb-2">
                                  {checkMessage(item)}
                                </div>
                              </div>
                            )
                          )
                        ) : item?.type === "chat" ? (
                          <div className="flex justify-start items-center space-x-2 px-2 pb-6">
                            <div className="bg-[#0d2d5e] rounded-full text-white max-h-7 max-w-[1.75rem] px-4 py-4 flex items-center justify-center">
                              {data?.job_id?.company_id?.company_name
                                ?.slice(0, 1)
                                ?.toUpperCase()}
                            </div>
                            <div>
                              <div className="flex-1 flex justify-start items-center space-x-2">
                                <div className="text-sm">
                                  {getTimeFromDate(item?.createdAt)}
                                </div>
                              </div>
                              <div className="text-[#595959]">
                                {item?.message}
                              </div>
                              {item?.file_id && <ChatImg item={item}></ChatImg>}
                              <div />
                            </div>
                          </div>
                        ) : (
                          Object.values(CHAT_TYPE)?.includes(item?.type) && (
                            <div className="text-center">
                              <div className="rounded-lg inline-block bg-[#ff39b3] font-bold px-5 py-0.5  text-white mb-2">
                                {item?.message}
                              </div>
                            </div>
                          )
                        )}
                      </div>
                    ))}
                  {showRating === "add" && (
                    <Rating handleData={handleData}></Rating>
                  )}
                  {showRating === "view" && (
                    <ViewRating data={allReview}></ViewRating>
                  )}
                </div>
              </div>
              <ChatBottom
                handleImageClick={handleImageClick}
                imageUrl={imageUrl}
                uploadChange={handleImage}
                Send={sendMessage}
                onChange={(e) => setMessage(e.target.value)}
                value={message}
                Clear={() => setMessage("")}
              />
            </div>
          </div>
        </main>
      </ContentWithSpinner>
      {model && (
        <ModelWrapperWithButton
          showModal={model}
          onCheckModel={onCheckModel}
          Save={loader === "submit" ? null : handleChange}
        >
          {model === "changeDate" && (
            <div>
              {/* Date Picker */}
              <ReactDatePicker
                onChange={(date) => setStartDate(date)}
                selected={startDate}
                minDate={new Date()}
                label={
                  <FormattedMessage
                    id="RECRUITER.SCHEDULEWORKORDER.INPUT.SCHEDULEDATE"
                    defaultMessage="Schedule Date"
                  />
                }
                inputClass="rounded-lg"
                labelClass="mt-2 text-black"
                InputDivClass="mt-0 w-26 pr-2 pb-2"
                type="date"
                placeholder="Schedule date"
              />

              {/* Time Range */}
              <div className="mt-4">
                <p className="text-black text-base">Time Range</p>

                <ReactTimePicker
                  labelClass="mt-2 text-gray-700"
                  InputDivClass="mt-2 pr-2 pb-2"
                  value={from}
                  onChange={(value) => setFrom(value)}
                  showSecond={false}
                  label="Start Time"
                />

                <ReactTimePicker
                  labelClass="mt-2 text-gray-700"
                  InputDivClass="mt-0 pr-2 pb-2"
                  value={to}
                  onChange={(value) => setTo(value)}
                  showSecond={false}
                  label="End Time"
                />
              </div>
            </div>
          )}

          {model === "changeRate" && (
            <div className="flex items-center pb-3 mb-3 space-x-3">
              <Input
                inputClass="rounded-lg [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
                label={
                  <FormattedMessage
                    id="INDIVIDUAL.JOBS.PAYTYPE.RATE.INPUT.PLACEHOLDER"
                    defaultMessage="Enter Rate"
                  />
                }
                onChange={(e) => setRate(e.target.value)}
                type="number"
                labelClass="mt-2 text-black"
                InputDivClass="mt-0 w-26 pr-2 pb-2"
                prefix="$"
                value={rate}
              />

              {/* {errors?.pay_type ? (
                    <p className="mt-1 text-red-400 md:text-sm sm:text-[.65rem]">
                      {validationErrorHandle(errors?.pay_type)}
                    </p>
                  ) : (
                    ""
                  )} */}
            </div>
          )}
        </ModelWrapperWithButton>
      )}
      {showDelete && (
        <ModelWrapper
          rounded="rounded-[10px]"
          background="bg-[#00000099]"
          position="fixed"
          opacity="opacity-100"
          topPosition="top-[10%]"
          rightPosition="inset-0"
          width="w-[50%] mx-auto"
          showModal={showDelete}
          HandleModelByProps={() => setShowDelete(false)}
        >
          <DeleteConfirmation
            noCancelText={"No"}
            text="Are you sure you want to cancel your cleaning?"
            onCancel={() => setShowDelete(false)}
            onDelete={() => handleCancel()}
          />
        </ModelWrapper>
      )}
    </MainWrapper>
  );
};
